module.exports = __webpack_public_path__ + "static/img/gold3.83475ee0.png";